

























































































































































































































import * as _ from 'lodash';
import tippy from 'tippy.js';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PlanNode from '@/components/PlanNode.vue';
import Diagram from '@/components/Diagram.vue';
import Stats from '@/components/Stats.vue';
import { HelpService, scrollChildIntoParentView } from '@/services/help-service';
import { PlanService } from '@/services/plan-service';
import { cost, duration, durationClass, json, pgsql, rows } from '@/filters';
import { CenterMode, HighlightMode, HighlightType, NodeProp, Orientation, ViewMode } from '../enums';
import { IPlan } from '../iplan';
import Node from '../inode';

import Dragscroll from '@/dragscroll';

import VueTippy, { TippyComponent } from 'vue-tippy';
Vue.use(VueTippy);
Vue.component('tippy', TippyComponent);

@Component({
  name: 'plan',
  components: {
    Diagram,
    Pane,
    PlanNode,
    Splitpanes,
    Stats,
  },
  directives: {
  },
  filters: {
    cost,
    duration,
    durationClass,
    json,
    pgsql,
    rows,
  },
})
export default class Plan extends Vue {
  public $refs!: {
    plan: InstanceType<typeof Pane>,
    root: PlanNode,
  };

  @Prop(String) private planSource!: string;
  @Prop(String) private planQuery!: string;
  private queryText!: string;
  private plan!: IPlan | null;
  private rootNode!: any;
  private flat: any[] = [];
  private menuHidden: boolean = true;
  private validationMessage: string = '';
  private showTriggers: boolean = false;
  private showSettings: boolean = false;
  private activeTab: string = '';
  private highlightTimeout!: number;

  private helpService = new HelpService();
  private lodash = _;

  private eventBus = new Vue();

  private viewOptions: any = {
    menuHidden: true,
    showHighlightBar: false,
    showPlanStats: true,
    highlightType: HighlightType.NONE,
    viewMode: ViewMode.FULL,
    orientation: Orientation.TWOD,
    showDiagram: true,
    diagramWidth: 20,
  };

  private highlightTypes = HighlightType;
  private viewModes = ViewMode;
  private orientations = Orientation;

  private planService = new PlanService();
  private nodeProps = NodeProp;

  private mounted(): void {
    this.handleScroll();
    this.eventBus.$on('mouseovernode', this.onMouseOverNode);
    this.eventBus.$on('mouseoutnode', this.onMouseOutNode);
    this.eventBus.$on('clicknode', this.centerNode);
    this.eventBus.$on('clickcte', this.centerCTE);
  }

  private handleScroll(): void {
    const el: Element = this.$refs.plan.$el as Element;
    const scroll = new Dragscroll(el);
  }

  private created(): void {
    const savedOptions = localStorage.getItem('viewOptions');
    if (savedOptions) {
      _.assignIn(this.viewOptions, JSON.parse(savedOptions));
    }
    let planJson: any;
    try {
      planJson = this.planService.fromSource(this.planSource);
      this.validationMessage = '';
      this.setActiveTab('plan');
    } catch (e) {
      this.validationMessage = 'Couldn\'t parse plan';
      this.plan = null;
      return;
    }
    this.rootNode = planJson.Plan;
    this.queryText = planJson['Query Text'] || this.planQuery;
    this.plan = this.planService.createPlan('', planJson, this.queryText);
    const content = this.plan.content;
    this.plan.planStats = {
      executionTime: content['Execution Time'] || content['Total Runtime'] || null,
      planningTime: content['Planning Time'] || null,
      maxRows: content.maxRows || null,
      maxCost: content.maxCost || null,
      maxDuration: content.maxDuration || null,
      maxBlocks: content.maxBlocks || null,
      triggers: content.Triggers || [],
      jitTime: content.JIT && content.JIT.Timing && content.JIT.Timing.Total || null,
      settings: content.Settings,
    };

    Vue.nextTick(() => {
      this.centerNode(this.rootNode, CenterMode.visible, HighlightMode.flash);
      // build the diagram structure
      // with level and reference to PlanNode components for interaction
      if (!this.plan) {
        return;
      }
    });
  }

  @Watch('viewOptions', {deep: true})
  private onViewOptionsChanged(val: any, oldVal: any) {
    localStorage.setItem('viewOptions', JSON.stringify(this.viewOptions));
  }

  private showHideMenu(): void {
    this.viewOptions.menuHidden = !this.viewOptions.menuHidden;
  }

  private getHelpMessage(message: string) {
    return this.helpService.getHelpMessage(message);
  }

  private showSlowestNode() {
    this.centerNode(this.plan!.content.slowest, CenterMode.center, HighlightMode.flash);
  }

  private showCostliestNode() {
    this.centerNode(this.plan!.content.costliest, CenterMode.center, HighlightMode.flash);
  }

  private centerNode(node: any, centerMode: CenterMode, highlightMode: HighlightMode) {
    const cmp = _.find(this.plan!.nodeComponents, (c) => c.node === node);
    if (!cmp) {
      return;
    }
    this.highlightEl(cmp.$el.querySelector('.plan-node'), centerMode, highlightMode);
  }

  private highlightEl(el: Element | HTMLElement | null, centerMode: CenterMode, highlightMode: HighlightMode) {
    if (!el) {
      return;
    }
    const parent = this.$refs.plan.$el;
    if (centerMode !== CenterMode.none) {
      scrollChildIntoParentView(parent, el, centerMode === CenterMode.center, () => {
        if (highlightMode === HighlightMode.flash) {
          el.classList.add('flash');
          setTimeout(() => {
            el.classList.remove('flash');
          }, 1000);
        }
      });
    }
  }

  private highlightNode(node: any, highlight: boolean) {
    const highlighted = this.$el.querySelector('.plan-node.highlight');
    if (highlighted) {
      highlighted.classList.remove('highlight');
    }

    window.clearTimeout(this.highlightTimeout);
    this.highlightTimeout = window.setTimeout((() => {
      const cmp = _.find(this.plan!.nodeComponents, (c) => c.node === node);
      if (!cmp) {
        return;
      }
      const el = cmp.$el.querySelector('.plan-node');
      el!.classList.toggle('highlight', highlight);
    }).bind(this), 50);
  }

  private centerCTE(cteName: string) {
    const cmp = _.find(this.plan!.nodeComponents, (c) => c.node[NodeProp.SUBPLAN_NAME] === cteName);
    if (!cmp) {
      return;
    }
    this.highlightEl(cmp.$el, CenterMode.visible, HighlightMode.flash);
  }

  private get totalTriggerDurationPercent() {
    const plan = this.plan;
    const planStats = this.plan && this.plan.planStats;
    const executionTime = this.plan && this.plan.planStats.executionTime || 0;
    const totalDuration = this.triggersTotalDuration || 0;
    return _.round(totalDuration / executionTime * 100);
  }

  private triggerDurationPercent(trigger: any) {
    const plan = this.plan;
    const planStats = this.plan && this.plan.planStats;
    const executionTime = this.plan && this.plan.planStats.executionTime || 0;
    const time = trigger.Time;
    return _.round(time / executionTime * 100);
  }

  private toggleDiagram(): void {
    this.viewOptions.showDiagram = !this.viewOptions.showDiagram;
  }

  private timelineTooltip(cmp: PlanNode): string {
    if (this.plan) {
      return [
        'Duration: ',
        duration(cmp.node[NodeProp.EXCLUSIVE_DURATION], true),
        ' | ',
        cmp.executionTimePercent,
        '%',
      ].join('');
    }
    return '';
  }

  private planningTimeClass(percent: number) {
    let c;
    if (percent > 90) {
      c = 4;
    } else if (percent > 40) {
      c = 3;
    } else if (percent > 10) {
      c = 2;
    }
    if (c) {
      return 'c-' + c;
    }
    return false;
  }

  private get triggersTotalDuration() {
    if (!this.plan) {
      return;
    }
    return _.sumBy(this.plan.planStats.triggers, (o) => o.Time);
  }

  private onMouseOverNode(node: any) {
    this.highlightNode(node, true);
  }

  private onMouseOutNode(node: any) {
    this.highlightNode(node, false);
  }

  private setActiveTab(tab: string) {
    this.activeTab = tab;
  }
}
